import { Type } from "class-transformer";

export class FinancialLogImportOutDTO {
  @Type(() => Date)
  importDate!: Date;

  addedEntries!: number;
}
